import React from "react"

export default function Button(props) {
    return (
        <button {...props} className={`button--${props.disabled ? 'disabled': 'primary'} ${props.className}`}>
            <h4>{props.children}</h4>
        </button>
    )
}